<ng-container [ngSwitch]="language$ | async" class="ion-padding">
  <app-cgu-en *ngSwitchCase="'en'"></app-cgu-en>
  <app-cgu-fr *ngSwitchCase="'fr'"></app-cgu-fr>
</ng-container>
